export const SET_REPORT = 'SET_REPORT'
export const SET_STATUSES_FILTER = 'SET_STATUSES_FILTER'
export const SET_AGENTS_FILTER = 'SET_AGENTS_FILTER'
export const SET_QUEUES_FILTER = 'SET_QUEUES_FILTER'
export const RESET_AGENTS_FILTER = 'RESET_AGENTS_FILTER'
export const RESET_STATUSES_FILTER = 'RESET_STATUSES_FILTER'
export const RESET_QUEUES_FILTER = 'RESET_QUEUES_FILTER'
export const RESET_REPORT = 'RESET_REPORT'
